import { render, staticRenderFns } from "./OrderProductDetail.vue?vue&type=template&id=a057864c&scoped=true&"
import script from "./OrderProductDetail.vue?vue&type=script&lang=js&"
export * from "./OrderProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductDetail.vue?vue&type=style&index=0&id=a057864c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a057864c",
  null
  
)

export default component.exports